import { CombinedGraphQLErrors } from '@apollo/client/errors';
import { ErrorLink } from '@apollo/client/link/error';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

const isDatadogBrowserEnabled =
  process.env.NODE_ENV !== 'development' &&
  Boolean(process.env.REACT_APP_DD_APPLICATION_ID) &&
  Boolean(process.env.REACT_APP_DD_CLIENT_TOKEN);

/**
 * Reports GraphQL and network errors from the Apollo link chain to Datadog
 * (replaces former apollo-link-sentry coverage).
 */
export const datadogGraphqlErrorLink = new ErrorLink(({ error, operation }) => {
  if (!isDatadogBrowserEnabled) {
    return;
  }

  const operationName = operation.operationName ?? 'unknown';

  if (CombinedGraphQLErrors.is(error)) {
    for (const err of error.errors) {
      datadogLogs.logger.error('GraphQL error', {
        operation: operationName,
        gqlPath: err.path,
        message: err.message,
        code: err.extensions?.code,
      });
      datadogRum.addError(
        new Error(`[GraphQL ${operationName}] ${err.message}`),
      );
    }
    return;
  }

  datadogLogs.logger.error('GraphQL network error', {
    operation: operationName,
    message: error.message,
    name: error.name,
  });
  datadogRum.addError(error);
});
